import { Box, Button, Modal, TextField, Typography } from '@material-ui/core';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { Autocomplete, IconButton, Paper } from "@mui/material";
import { DataGrid } from '@mui/x-data-grid';
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Nabvar from '../../common/Nabvar';
import Sidebar from '../../common/Sidebar';
import axios from "../../config/authaxios";
import { useStyles } from "../../theme/theme";
import Body from "../../ui/Body";
import CloseIcon from "@mui/icons-material/Close";
import "../../css/coupon.module.scss"

import { Stack } from '@mui/system';
// global veriables
let propsData = {};

// style
const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 500,
    background: "#fff",
    boxShadow: 24,
    padding: 20,
};

function DetailCoupon() {
    const classes = useStyles();
    const search = useLocation().search;
    const SKU = new URLSearchParams(search).get("SKU");
    const [profitId, setProfitId] = useState("")
    const price = new URLSearchParams(search).get("prices");
    const prices = price.split(",")
    const type = [{ type: 1, name: "Percentage" }, { type: 2, name: "Amount" }]
    const [formData, setFormData] = useState({
        sku: SKU,
        price: 0,
        type: "",
        profit: 0
    })
    const [open, setOpen] = useState(false);
    const [editable, setEditable] = useState(false);
    const navigate = useNavigate();

    const [coupon, setCoupon] = useState([])
    const fetchCouponData = () => {
        axios.get(`/admin/product/profit/list/by/sku/${SKU}/0/10`)
            .then((res) => {
                if (res.status === 200) {
                    let data = res.data.response
                    setCoupon(data);
                }
            }).catch((err) => console.log(err))
    }


    const couponsColomns = [
        {
            field: 's_no',
            headerName: 'S. No.',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            filterable: false,
            renderCell: (index) => index.api?.getRowIndexRelativeToVisibleRows(index.row._id) + 1,
        },
        {
            field: '_id',
            headerName: 'ID',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 200,
            renderCell: (params) => {
                return (
                    <p>
                        {params?.row?._id}
                    </p>
                )
            },
        },
        {
            field: 'p_sku',
            headerName: 'SKU',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 200,
        },

        {
            field: 'p_price',
            headerName: 'Price',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 200,
        },
        {
            field: 'type',
            headerName: 'Type',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 200,
            renderCell: (params) => {
                if (params?.row.type === 1) {
                    return <p>Percentage</p>
                } else {
                    return <p>Number</p>
                }
            },
        },
        {
            field: 'profit',
            headerName: 'Profit',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 200,
        },
        {
            field: 'is_deleted',
            headerName: 'is_deleted',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 200,
        },
        {
            field: 'edit', headerName: 'Edit Price',
            renderCell: (params) => {
                return (
                    <IconButton
                    ><EditIcon color='primary' onClick={() => {
                        setProfitId(params.row._id);
                        setOpen(true);
                        setEditable(true);
                    }} />
                    </IconButton>
                )
            },
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 150,
        },
        {
            field: 'delete',
            headerName: 'Delete Price',
            renderCell: (params) => {
                return (
                    <IconButton
                    ><DeleteIcon color='error' onClick={() => deleteHandler(params?.row._id)} />
                    </IconButton>
                )
            },
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 150,
            hide: true,
        },


        {
            field: 'created_at',
            headerName: 'Created At',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 200,
        },
        {
            field: 'updated_at',
            headerName: 'Updated At',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 200,
        },
    ]

    const addPrice = () => {
        setOpen(true)
        setEditable(false)
    }
    const handleClose = () => {
        setOpen(false)
        setEditable(false)
    }

    const addProfit = (e) => {
        e.preventDefault();
        const newForm = {
            sku: formData.sku,
            price: Number(formData.price),
            type: formData.type,
            profit: Number(formData.profit)
        }
        axios.post(`/admin/product/profit/create`, newForm).then((res) => {
            fetchCouponData(); handleClose();
        });

    }

    const editHandler = async (e) => {
        e.preventDefault()
        const newForm = {
            profitId: profitId,
            price: Number(formData.price),
            type: formData.type,
            profit: Number(formData.profit)
        }
        axios.put(`/admin/product/profit/update`, newForm).then((res) => {
            fetchCouponData(); handleClose();
        });


    };
    const deleteHandler = async (e) => {
        const res = await axios.delete("/admin/product/profit/delete", {
            data: { profitId: e },
        });
        const data = await res.data;
        if (data) {
            handleClose();
            fetchCouponData();
        }
    };

    useEffect(() => {
        fetchCouponData()
    }, [])
    return (
        <>
            <section  >
                <Sidebar />
                <Nabvar />
            </section >
            {/* body */}


            <Body >
                <Button sx={{ mb: 2 }} variant="contained" onClick={addPrice}>Add Price</Button>
                <Paper sx={{
                    bgcolor: '#fff',
                    '& .super-app-theme--header': {
                        bgcolor: '#DC8449',
                        color: '#fff',
                    },
                }} elevation={0}>

                    <DataGrid
                        className={classes.root}
                        sx={{
                            border: 0,
                        }}
                        hideFooterPagination
                        getRowHeight={() => 'auto'}
                        autoHeight
                        rows={coupon}
                        columns={couponsColomns}
                        getRowId={(row) => row._id}
                        disableSelectionOnClick
                        disableRowSelectionOnClick
                        experimentalFeatures={{ newEditingApi: true }}
                        //  pagination
                        // pageSize={pageSize}
                        // onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                        rowsPerPageOptions={[25, 50, 100]}
                        disableColumnSelector

                    />
                </Paper>
                <Modal
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box style={style}>
                        <Stack
                            direction="row"
                            sx={{ diplay: "flex", justifyContent: "space-between" }}
                        >
                            <Typography variant="h5">{editable ? "Add" : "Edit"} Profit</Typography>
                            <IconButton onClick={handleClose}>
                                <CloseIcon />
                            </IconButton>
                        </Stack>
                        <form>
                            <Autocomplete
                                disablePortal

                                options={
                                    prices?.map((items) => items)
                                }
                                onChange={(event, newValue) => {
                                    setFormData({ ...formData, price: newValue });
                                }}

                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Prices"
                                    />
                                )}
                            />

                            <Autocomplete
                                disablePortal
                                onChange={(event, newValue) => {
                                    setFormData({ ...formData, type: newValue.type });
                                }}
                                options={type}
                                getOptionLabel={option => option.name}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Type"
                                    />
                                )}
                            />
                            <TextField
                                type="text"
                                className="rounded  py-2"
                                id="name"
                                onChange={(event) => {
                                    setFormData({ ...formData, profit: event.target.value });
                                }}
                            // placeholder="Enter App version"
                            />
                            <Stack direction="row" sx={{ mt: 2 }} spacing={2}>
                                <Button variant="contained" color="primary" type="submit" onClick={(e) => {
                                    editable ?
                                        editHandler(e) : addProfit(e)
                                }}>
                                    Link
                                </Button>
                                <Button variant="contained" color="error" >
                                    Close
                                </Button>
                            </Stack>
                        </form>
                    </Box>
                </Modal>
            </Body>




        </>
    )
}

export default DetailCoupon